import SelectDateCity from "./SelectDateCity/SelectDateCity";
import * as S from "./SearchTheatresSection.style";

const SearchTheatresSection = () => {
  return (
    <>
      <S.SearchTheatersContainer id="select-date-city-container">
        <S.TitleContainer>
          <S.SearchHeading>
            India's Best Private Theatre Venue for Celebrations
          </S.SearchHeading>
          <S.SearchSubHeading>
            Book Your Perfect Celebration: Birthdays, Anniversaries, Date Nights
            & More!
          </S.SearchSubHeading>
        </S.TitleContainer>
        <S.SelectDateCityContainer>
          <SelectDateCity />
        </S.SelectDateCityContainer>
      </S.SearchTheatersContainer>
    </>
  );
};
export default SearchTheatresSection;
